(function() {
    'use strict';

    angular
        .module('app')
        .directive('drvWorkflowRunStepsList', drvWorkflowRunStepsList);

    drvWorkflowRunStepsList.$inject = [];
    
    function drvWorkflowRunStepsList() {
        var directive = {
            controller: WorkflowRunStepsListCtrl,
            controllerAs: 'drvCtrl',
            bindToController: {
                instanceStack: '<',
                userLabel: '<?'
            },
            restrict: 'EA',
            scope: { },
            templateUrl: 'app/workflow/workflow-run-steps-list.tmpl.html'
        };

        WorkflowRunStepsListCtrl.$inject = [];

        return directive;

        function WorkflowRunStepsListCtrl() {
        }
    }
})();